import React, { useCallback } from 'react';
import {
  Divider,
  Typography,
  List,
  ListItem,
  ListItemText,
  Theme,
  Box,
  Hidden,
  Drawer,
  ListItemIcon,
} from '@mui/material';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import { createStyles, makeStyles } from '@mui/styles';
import { useNavigate } from 'react-router-dom';
import { SETTING_ROUTES } from './layout-utils';
import { PRIMARY_COLOR } from '../../../css/theme';
import { openMobileMenuEvent } from './user-events';
import { useStore } from '@cobuildlab/react-simple-state';
import { closeMobileMenu } from './user-actions';
import LaunchIcon from '@mui/icons-material/Launch';
//import MailOutlineIcon from '@mui/icons-material/MailOutline';
import PowerSettingsNewSharpIcon from '@mui/icons-material/PowerSettingsNewSharp';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import { useAuth } from '../../../../modules/auth/auth-hook';
import { SubscriptionStatuses } from '../../../types/generated';

const useStyles = makeStyles<Theme>(() =>
  createStyles({
    textRed: {
      color: PRIMARY_COLOR,
      fontFamily: 'manop !important',
    },
    textNormal: {
      color: 'black',
      cursor: 'pointer',
      fontFamily: 'manop !important',
    },
    listItem: {
      '& > span': {
        fontWeight: 'bold',
      },
    },
    helpCenter: {
      color: 'black',
      '&:hover': {
        color: '#0080ff',
      },
    },
  }),
);

export const Menu: React.FC = () => {
  const classes = useStyles();
  const navigate = useNavigate();
  const { open } = useStore(openMobileMenuEvent);
  const { user } = useAuth();
  const [routes, setRoutes] = React.useState(SETTING_ROUTES);
  const subActive = user?.subscriptions?.filter(
    (i) => i?.status === SubscriptionStatuses.Active,
  )?.[0];
  const handleChangeRoutes = useCallback(() => {
    if (
      user?.subscriptions?.some(
        (sub) => sub?.plan?.subscription_student_credential_is_required,
      )
    ) {
      setRoutes([
        ...SETTING_ROUTES,
        {
          name: 'Perfil estudiantil',
          path: '/perfil-estudiantil',
        },
      ]);
    }
  }, [user?.subscriptions]);

  React.useEffect(() => {
    handleChangeRoutes();
  }, [handleChangeRoutes, user?.subscriptions]);

  return (
    <>
      <Hidden mdDown={false} mdUp={true}>
        <Drawer anchor="left" open={open} onClose={() => closeMobileMenu()}>
          <Box sx={{ width: 250 }} onClick={() => closeMobileMenu()}>
            <ListItem divider>
              <Typography
                fontFamily={'oswald'}
                color="primary"
                fontWeight="bold"
              >
                TU CONTENIDO
              </Typography>
            </ListItem>
            {routes.map((route) => {
              if (route.name === 'Mis notas guardadas' && !subActive) {
                return null;
              }
              return (
                <ListItem
                  divider
                  className={
                    route.path === location.pathname
                      ? classes.textRed
                      : classes.textNormal
                  }
                  onClick={() => {
                    navigate(route.path);
                  }}
                >
                  <ListItemText
                    primaryTypographyProps={{ fontFamily: 'manop' }}
                    primary={route.name}
                  />
                  <ArrowForwardIosIcon fontSize="small" />
                </ListItem>
              );
            })}

            <List component="nav" aria-label="mailbox folders">
              <ListItem divider>
                <Typography
                  fontFamily={'oswald'}
                  color="primary"
                  fontWeight="bold"
                >
                  AYUDA
                </Typography>
              </ListItem>
            </List>

            <List component="nav" aria-label="mailbox folders">
              <ListItem
                divider //mailto:suscripciones@animalpolitico.com
                component="a"
                href="https://wa.me/525610190580"
                target="_blank" //<MailOutlineIcon fontSize="small" />
                style={{ color: 'black' }}
              >
                <ListItemText
                  primaryTypographyProps={{ fontFamily: 'manop' }}
                  primary="Contáctanos"
                />
                <WhatsAppIcon fontSize="small" />
              </ListItem>

              <a
                style={{
                  textDecoration: 'none',
                  color: 'black',
                  display: 'none',
                }}
                target="_blank"
                href="#"
              >
                <ListItem divider>
                  <ListItemText
                    primaryTypographyProps={{ fontFamily: 'manop' }}
                    style={{ fontSize: '16px' }}
                    primary="Escríbenos a Whatsapp"
                  />
                  <WhatsAppIcon fontSize="small" />
                </ListItem>
              </a>
              <a
                style={{
                  textDecoration: 'none',
                  color: 'black',
                  display: 'none',
                }}
                target="_blank"
                href="#"
              >
                <ListItem divider>
                  <ListItemText
                    style={{ fontSize: '16px' }}
                    primaryTypographyProps={{ fontFamily: 'manop' }}
                    primary="Centro de ayuda"
                  />
                  <LaunchIcon fontSize="small" />
                </ListItem>
              </a>
              <div style={{ marginTop: '100px' }}>
                <Divider />
                <ListItem
                  className={classes.textNormal}
                  onClick={() => navigate('/logout')}
                >
                  <ListItemIcon>
                    <PowerSettingsNewSharpIcon fontSize="small" />
                  </ListItemIcon>
                  <ListItemText
                    primaryTypographyProps={{ fontFamily: 'manop' }}
                    primary="Cerrar sesión"
                  />
                </ListItem>
              </div>
            </List>
          </Box>
        </Drawer>
      </Hidden>
      <Hidden mdDown={true} mdUp={false}>
        <Box>
          <List component="nav" aria-label="mailbox folders">
            <ListItem divider>
              <Typography
                fontFamily={'oswald'}
                color="primary"
                fontWeight="bold"
              >
                TU CONTENIDO
              </Typography>
            </ListItem>
            {routes.map((route) => {
              if (route.name === 'Mis notas guardadas' && !subActive) {
                return null;
              }
              return (
                <ListItem
                  divider
                  className={
                    route.path === location.pathname
                      ? classes.textRed
                      : classes.textNormal
                  }
                  onClick={() => {
                    navigate(route.path);
                  }}
                >
                  <ListItemText
                    primaryTypographyProps={{ fontFamily: 'manop' }}
                    primary={route.name}
                  />
                  <ArrowForwardIosIcon fontSize="small" />
                </ListItem>
              );
            })}
          </List>
          <List component="nav" aria-label="mailbox folders">
            <ListItem divider>
              <Typography
                fontFamily={'oswald'}
                color="primary"
                fontWeight="bold"
              >
                AYUDA
              </Typography>
            </ListItem>
          </List>

          <List component="nav" aria-label="mailbox folders">
            <ListItem
              divider //mailto:suscripciones@animalpolitico.com
              component="a"
              href="https://wa.me/525610190580"
              target="_blank" //<MailOutlineIcon fontSize="small" />
              style={{ color: 'black' }}
            >
              <ListItemText
                primaryTypographyProps={{ fontFamily: 'manop' }}
                primary="Contáctanos"
              />
              <WhatsAppIcon fontSize="small" />
            </ListItem>
            <a
              style={{
                textDecoration: 'none',
                color: 'black',
                display: 'none',
              }}
              target="_blank"
              href="#"
            >
              <ListItem divider>
                <ListItemText
                  style={{ fontSize: '16px' }}
                  primaryTypographyProps={{ fontFamily: 'manop' }}
                  primary="Escríbenos a Whatsapp"
                />
                <WhatsAppIcon fontSize="small" />
              </ListItem>
            </a>
            <a
              style={{
                textDecoration: 'none',
                color: 'black',
                display: 'none',
              }}
              target="_blank"
              href="#"
            >
              <ListItem divider>
                <ListItemText
                  style={{ fontSize: '16px' }}
                  primaryTypographyProps={{ fontFamily: 'manop' }}
                  primary="Centro de ayuda"
                />
                <LaunchIcon fontSize="small" />
              </ListItem>
            </a>

            <div style={{ marginTop: '100px' }}>
              <Divider />
              <ListItem
                className={classes.textNormal}
                onClick={() => navigate('/logout')}
              >
                <ListItemIcon>
                  <PowerSettingsNewSharpIcon fontSize="small" />
                </ListItemIcon>
                <ListItemText
                  primaryTypographyProps={{ fontFamily: 'manop' }}
                  primary="Cerrar sesión"
                />
              </ListItem>
            </div>
          </List>
        </Box>
      </Hidden>
    </>
  );
};
